import { z } from 'zod';
export const citationValidationStateSchema = z.enum(['pending', 'passed', 'failed']);
export const citationReasonFamilySchema = z.enum([
    'unknown_or_unread_file',
    'unretrieved_architecture_or_doc_handle',
    'malformed_identifier',
    'permission_blocked_evidence',
    'never_in_consultation_manifest',
    'internal_validation_error',
]);
export const CITATION_REASON_FAMILIES = [
    'unknown_or_unread_file',
    'unretrieved_architecture_or_doc_handle',
    'malformed_identifier',
    'permission_blocked_evidence',
    'never_in_consultation_manifest',
    'internal_validation_error',
];
export const citationKindSchema = z.enum([
    'repository_file_span',
    'architecture_decision',
    'internal_doc_chunk',
    'tracker_issue',
]);
export const repositorySpanDeclaredSchema = z.object({
    repository_id: z.string().uuid(),
    path: z.string().min(1),
    line_start: z.number().int(),
    line_end: z.number().int(),
});
export const adrDeclaredSchema = z.object({
    adr_id: z.string().uuid(),
});
export const internalDocDeclaredSchema = z.object({
    handle: z.string().min(1),
});
export const trackerDeclaredSchema = z.object({
    external_key: z.string().min(1),
});
export const structuredCitationSchema = z.object({
    citation_id: z
        .string()
        .min(1)
        .max(128)
        .regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/),
    kind: citationKindSchema,
    declared_identifier: z.unknown(),
    section_anchor: z.string().max(512).nullable().optional(),
});
export const citationValidationFindingSchema = z.object({
    citation_id: z
        .string()
        .min(1)
        .max(128)
        .regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/),
    ok: z.boolean(),
    reason_family: citationReasonFamilySchema.nullable().optional(),
    detail_code: z.string().max(64).nullable().optional(),
});
export const consultationManifestEntrySchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('repository_file'),
        repository_id: z.string().uuid(),
        path: z.string().min(1),
        line_start: z.number().int().optional(),
        line_end: z.number().int().optional(),
    }),
    z.object({
        kind: z.literal('architecture_decision'),
        adr_id: z.string().uuid(),
    }),
    z.object({
        kind: z.literal('internal_doc_chunk'),
        handle: z.string().min(1),
    }),
    z.object({
        kind: z.literal('tracker_issue'),
        external_key: z.string().min(1),
    }),
]);
export const consultationManifestSchema = z.array(consultationManifestEntrySchema);
export function parseStructuredCitations(raw) {
    const arr = z.array(structuredCitationSchema).max(256).parse(raw);
    return arr;
}
export function parseConsultationManifestEntries(raw) {
    return consultationManifestSchema.max(4096).parse(raw);
}
//# sourceMappingURL=citation-validation.schemas.js.map